export enum SmsTemplates {
  DefaultSms = 4,
}
